import React from "react";
import * as Yup from "yup";
import Modal from "components/Modal";
import cls from "./modal.module.scss";
import { Button } from "@duik/it";
import className from "classnames";
import { Formik, FormikProps } from "formik";
import { useDispatch } from "react-redux";
import { useRedux } from "@redux";
import FormInputGroup from "../../../../components/FormInputGroup";
import Input from "../../../../components/Input";
/**
 * Type of Formvalues
 */
interface FormValues {
  implantSummary: string;
}

/**
 * Form Schema
 * @returns errors
 */
const AddImplantSummarySchema = Yup.object().shape({
  implantSummary: Yup.string().required("Summary is empty"),
});

export const AddImplantSummary = ({
  handleClose,
  isOpen,
  customerProfiledata,
  handleDelete,
  handleUpdate,
}) => {
  const dispatch = useDispatch();

  const customerProfileState = useRedux("customerProfile");
  const [isDeleting, setIsDeleting] = React.useState(false);
  // Inital formvalues
  const initialValues: FormValues = {
    implantSummary: customerProfiledata.config?.implantSummary || "",
  };

  React.useEffect(() => {
    if (!customerProfileState.isUpdating) {
      setIsDeleting(false);
      handleClose();
    }
  }, [customerProfileState.isUpdating]);
  // Handle update
  const handleUpdateSummary = (data: any, actions: any) => {
    handleUpdate(data, customerProfiledata.id);
  };
  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      className={cls.modalWrapper}
    >
      <h2>
        {!customerProfiledata.config?.implantSummary
          ? "Edit Notes"
          : "Add Notes"}
      </h2>
      <br />
      <br />
      <Formik
        initialValues={initialValues}
        validationSchema={AddImplantSummarySchema}
        onSubmit={handleUpdateSummary}
      >
        {({
          errors,
          touched,
          handleChange,
          handleSubmit,
          handleBlur,
          values,
        }: FormikProps<FormValues>) => (
          <form onSubmit={handleSubmit}>
            <FormInputGroup>
              <FormInputGroup horizontal className={cls.summaryInput}>
                <Input
                  type="textarea"
                  label="NOTES"
                  name="implantSummary"
                  handleChange={handleChange}
                  onBlur={handleBlur}
                  errorMessage={
                    errors.implantSummary && touched.implantSummary
                      ? errors.implantSummary
                      : undefined
                  }
                  value={values?.implantSummary || ""}
                  placeholder="Notes..."
                />
              </FormInputGroup>
              <br />
              <Button
                isLoading={customerProfileState.isUpdating}
                className={className(cls.button, cls.modalBtn, cls.submitBtn)}
                type="submit"
              >
                SAVE NOTES
              </Button>
              {!customerProfileState.isUpdating && (
                <Button
                  className={className(cls.button, cls.modalBtn)}
                  style={{ backgroundColor: "transparent" }}
                  onClick={handleClose}
                >
                  CANCEL
                </Button>
              )}
              <br/>
              {!customerProfileState.isUpdating &&
                customerProfiledata.config?.implantSummary && (
                  <Button
                    className={className(
                      cls.button,
                      cls.modalBtn,
                      cls.deleteBtn
                    )}
                    isLoading={isDeleting && customerProfileState.isUpdating}
                    onClick={() => {
                      setIsDeleting(true);
                      handleDelete(customerProfiledata.id);
                    }}
                  >
                    DELETE NOTES
                  </Button>
                )}
            </FormInputGroup>
          </form>
        )}
      </Formik>
      <div style={{ height: 25 }} />

      <div style={{ height: 20 }} />
    </Modal>
  );
};
export default AddImplantSummary;
